import { Stack, Paper, Typography, CircularProgress, Button } from "@mui/material";

export const AlreadyCallDoneSearch = ({ motherID, searchStatus, errorMessage, onConfirmDelete }) => {
    return (
        <Paper sx={{ p: 2, mt: 2 }}>
            <Stack direction={"column"} spacing={2} alignItems="center">
                {searchStatus === "invalid" && (
                    <Typography variant="h6" color="error">Invalid Mother ID</Typography>
                )}
                {searchStatus === "searching" && (
                    <>
                        <Typography variant="h6">Searching for Call Done Cases</Typography>
                        <Typography variant="body1">Mother ID: {motherID}</Typography>
                        <CircularProgress />
                    </>
                )}
                {searchStatus === "found" && (
                    <>
                        <Typography variant="h6" color="success">Case Found!</Typography>
                        <Typography variant="body1">
                            A case already exists with Call Done for motherId: {motherID}.
                        </Typography>
                        <Button variant="contained" color="error" onClick={onConfirmDelete}>
                            Delete this allocation
                        </Button>
                    </>
                )}
                {searchStatus === "error" && (
                    <Typography variant="h6" color="error">{errorMessage}</Typography>
                )}
            </Stack>
        </Paper>
    );
};